import { http, HttpResponse } from 'msw';
import { HttpHeaders } from '@angular/common/http';
import { PlessService } from 'src/app/shared/pless-service.model';

export const kymw50Handlers = [
  // EC使用画像登録 KYMW50/registImageData
  http.post(PlessService.SERVICE.KYMW50registImageData.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(registImageData);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getSysE0100();
      // return ResponseUtils.getSys500();
    }
  ),
];

const registImageData = {
  status: "ok",
  message: "処理完了",
}